<div class="left-pane" (click)="onInteractionClicked($event)">
    <div class="three-stack">
        <div class="stack-child stack-child1" #stack>
            <div class="label" #labels>{{data[0][0]}}</div>
            <div [ngClass]="'text ' + hideText" *ngIf="data[0][1] !== undefined" #text>{{data[0][1]}}</div>
        </div>
        <div class="stack-child stack-child2" #stack>
            <div class="label" #labels>{{data[1][0]}}</div>
            <div [ngClass]="'text ' + hideText" *ngIf="data[1][1] !== undefined" #text>{{data[1][1]}}</div>
        </div>
        <div class="stack-child stack-child3" #stack>
            <div class="label" #labels>{{data[2][0]}}</div>
            <div [ngClass]="'text ' + hideText" *ngIf="data[2][1] !== undefined" #text>{{data[2][1]}}</div>
        </div>
    </div>
</div>
<arc-diagram id="test" [value1]="data[0][2]" [value2]="data[1][2]" [value3]="data[2][2]" [label]="label" 
  [text]="text !== undefined ? text : (label != undefined && label != '' ?  data[2][2] : '')" (click)="onInteractionClicked($event)">
</arc-diagram>
<div class="right-pane" (click)="onInteractionClicked($event)">
    <div class="panel-label">{{title}}</div>
</div>
